/* eslint-disable operator-linebreak */
import React from 'react';
import { useLocation } from 'react-router-dom';
import ArrowLeft from '../../assets/img/arrow-left.svg';

export default function BackButton() {
  const location = useLocation();
  const goBack = () => window.history.back();

  if (
    location?.pathname === '/' ||
    location.pathname === '/support' ||
    location.pathname === '/check-lease' ||
    location.pathname === '/blocked-verification-code' ||
    location.pathname === '/due-payment' ||
    location.pathname === '/congratulation'
  ) {
    return null;
  }

  return (
    <div className="k-back-wrapper">
      <button className="k-back-btn" type="button" onClick={goBack}>
        <img src={ArrowLeft} alt="Back Button" />
      </button>
    </div>
  );
}
